import type { Team } from 'api-client';

/**
 * Whether the "Shipped via Ahoy" footer toggle is locked ON for this org.
 *
 * The paid gate is enforced only when the org's `footerGateEnforced` flag
 * (the `email_footer_gate_enforced` RuntimeConfig switch, serialized per org)
 * is true — until then the whole feature runs in observe-only mode and the
 * toggle stays editable for everyone. Once enforced, the toggle locks unless
 * the org is known-paying (`isPayingCustomer === true`); an unknown paying
 * status locks, matching the server-side fail-closed stance.
 *
 * Single source of the client-side lock predicate — every surface that locks
 * the footer toggle must call this rather than re-deriving it.
 */
export function isFooterLocked(
  org: Pick<Team, 'isPayingCustomer' | 'footerGateEnforced'> | null | undefined
): boolean {
  if (org?.footerGateEnforced !== true) {
    return false;
  }
  return org.isPayingCustomer !== true;
}
